<template>
  <div id="theme-btn">
    <img
      v-if="theme === 'default'"
      src="../assets/light.png"
      @click="changeTheme">
    <img
      v-else
      src="../assets/dark.png"
      @click="changeTheme">
  </div>
</template>

<script>
// 依赖的外部类库
import {
  mapState,
  mapMutations
} from 'vuex'
import {
  UPDATE_THEME
} from '../store/mutation-type'
export default {
  name: 'ThemeBtn',
  computed: {
    ...mapState(['theme']) // vuex中获取页面配置,用户token,用户id等
  },
  methods: {
    ...mapMutations({ // vuex中的mutation混合
      updateTheme: UPDATE_THEME
    }),
    changeTheme () {
      let theme = this.theme === 'default' ? 'dark' : 'default'
      this.updateTheme(theme)
      this.$socket.emit('config', {theme})
    }
  }
}
</script>

<style scoped="scoped">
#theme-btn {
  cursor: pointer;
  user-select: none;
}
</style>
<style scoped="scoped">

</style>



// WEBPACK FOOTER //
// src/components/ThemeBtn.vue